@import '../../style/index';

:host {
  display: block;

  .stage {
    position: relative;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-position: center;
    background-size: cover;

    &__shadow {
      z-index: 5;
      position: absolute;
      width: 100%;
      height: 100%;
      background: var(--colors-stage-small-message-shadow);
    }

    &__content {
      z-index: 10;
      margin: rem-calc(96px) auto;
      min-height: 16rem;
      display: flex;
      align-items: center;
      justify-content: center;

      @include breakpoint($large) {
        margin: rem-calc(128px) auto;
      }

      &-headline {
        margin-top: 0;
      }
    }
  }
}
